// extracted by mini-css-extract-plugin
export default {"profile-info":"credit_profile-info__ZLIQG","total-balance":"credit_total-balance__4DCS3","balance-value":"credit_balance-value__Se+IY","loading":"credit_loading__OHcjT"};